export default __webpack_public_path__ + "static/media/team.23461f62.svg";